import React, { Component } from 'react';
import { Link, Router } from 'react-router-dom';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import RouterConfig from '../../router';
import { FooterStore } from '../../mobx/exportMobx';
import { hashHistory,browserHistory } from '../../utils/histoty';
import './index.scss';



@observer class Footer extends Component {

  render() {
    return (
      
      <Router history={browserHistory}>
        <RouterConfig />

        {/* 底部栏 */}
        <div className="footer">
          {this.renderFooter()}
        </div>
      </Router>
    );
  }

  componentDidMount = () => {
    this.matchRouter();
  }

  // 匹配进入当前的路由
  @action matchRouter = () => {
    let pathName = browserHistory.location.pathname,
      matchItem = FooterStore.tabs.findIndex(item => {
        return item.url === pathName;
      });
    FooterStore.currentItemIndex = matchItem;
  }

  // 渲染底部栏
  renderFooter = () => {
    let { tabs, currentItemIndex } = FooterStore;
    return tabs.map((item, index) => (<Link to={item.url} className="item" key={index} onClick={() => this.changeTab(index)}>
      <img className="icon" src={currentItemIndex === index ? item.activeIcon : item.icon} alt={item.title} />
      <span className={currentItemIndex === index ? 'title active' : 'title'}>{item.title}</span>
    </Link>));
  }

  // 切换tabs
  changeTab = (index) => {
    FooterStore.currentItemIndex = index;
  }

}


export default Footer;
